import React from "react";
import { Link } from "react-router-dom";
import { getAccessToken } from "../utils/fetchFunctions";
import "./ctasection.css";

const CTASection = () => {
  const accessToken = getAccessToken();
  const isLoggedIn = !!accessToken;

  return (
    <section className="cta-footer">
      <div className="cta-footer__inner">
        <div className="cta-footer__panel">
          <h3 className="cta-footer__title">
            {isLoggedIn ? "Welcome back!" : "Ready to start?"}
          </h3>
          <p className="cta-footer__copy">
            {isLoggedIn
              ? "Track your progress and continue your journey in the European Health Data Space."
              : "Create your account for free now and start your journey in the European Health Data Space."}
          </p>
          <div className="cta-footer__actions">
            <Link
              to={isLoggedIn ? "/dashboard" : "/register"}
              className="cta-footer__cta"
            >
              {isLoggedIn
                ? "Go to dashboard"
                : "✨ Create a free account"}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
